require('custom-event-polyfill');
require('element-closest');
import './promise-polyfill';
